import userInfo from 'hub-http/userInfo';
import { freeze } from 'immutable-less/immer';
import * as Scopes from 'automation-ui-canvas/constants/Scopes';
import { fetchHubScopes } from 'automation-ui-canvas/data/api/hubScopesApi';
import { hydrateUserInfo } from 'ui-asset-management-lib';
class Auth {
  createInstance() {
    return new Auth();
  }
  constructor() {
    this.data = {
      user: null,
      gates: null,
      portal: null,
      hubHasWorkflowsAccess: null
    };
    this.initialized = false;
  }
  init() {
    if (this.initialized) {
      throw new Error('Auth Utils: Cannot be initialized twice. Use getInstance() if you ' + 'need to create multiple instances.');
    }
    this.initialized = true;
    const hubHasWorkflowsPromise = userInfo().then(({
      portal: {
        portal_id
      },
      user: {
        scopes
      }
    }) => {
      if (scopes.includes(Scopes.WORKFLOWS_APP_ACCESS)) {
        return true;
      }
      return fetchHubScopes(portal_id).then(({
        scopes: hubScopes
      }) => {
        return hubScopes.includes(Scopes.WORKFLOWS_APP_ACCESS);
      }, () => false);
    });
    const userObjectTzPromise = userInfo().then(auth => hydrateUserInfo(auth).then(res => res.userObjectTimezone));
    return Promise.all([userInfo(), hubHasWorkflowsPromise, userObjectTzPromise]).then(([{
      portal,
      user,
      gates
    }, hubHasWorkflowsAccess, userObjectTimezone]) => {
      this.data = freeze({
        portal,
        user,
        gates,
        hubHasWorkflowsAccess,
        userObjectTimezone
      }, true);
      return this.data;
    });
  }
  get() {
    return this.data;
  }
  userHasWorkflowsAccess() {
    const user = this.data.user;
    return user && user.scopes.includes(Scopes.WORKFLOWS_APP_ACCESS);
  }
  hubHasWorkflowsAccess() {
    return this.data.hubHasWorkflowsAccess;
  }
}
export default new Auth();